import AspApi from 'api/ApiConfig';

export const fetchApps = async (brand_id) => {
  try {
    const params = {
      brand_id: brand_id 
    };
    const res = await AspApi.get(`/api/v1/integrations`, { params });
    return res;
  } catch (error) {
    throw error.response?.data || error.message || 'Failed to fetch integrations';
  }
};


export const connectApp = async (app_code, payload) => {
  try {
    const response = await AspApi.post(`/api/v1/integrations/${app_code}/connect/start`, payload);
    // Return the data from the response
    return response?.data || response;
  } catch (error) {
    throw error.response?.data || error.message || 'Failed to start connect app';
  }
};